// Intercepte les appels /cart/add pour injecter la couleur choisie
(function() {
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      var colorInput = document.getElementById('colorHiddenInput');
      if (colorInput && colorInput.value) {
        options = options || {};
        if (options.body instanceof FormData) {
          options.body.set('properties[Couleur]', colorInput.value);
        } else if (typeof options.body === 'string') {
          try {
            var data = JSON.parse(options.body);
            if (data.items && data.items.length > 0) {
              data.items.forEach(function(item) {
                if (!item.properties) item.properties = {};
                item.properties['Couleur'] = colorInput.value;
              });
            } else {
              if (!data.properties) data.properties = {};
              data.properties['Couleur'] = colorInput.value;
            }
            options.body = JSON.stringify(data);
          } catch(e) {}
        }
      }
    }
    return originalFetch.apply(this, arguments);
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._cartUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._cartUrl && this._cartUrl.indexOf('/cart/add') !== -1) {
      var colorInput = document.getElementById('colorHiddenInput');
      if (colorInput && colorInput.value) {
        if (body instanceof FormData) {
          body.set('properties[Couleur]', colorInput.value);
        } else if (typeof body === 'string') {
          try {
            var data = JSON.parse(body);
            if (data.items && data.items.length > 0) {
              data.items.forEach(function(item) {
                if (!item.properties) item.properties = {};
                item.properties['Couleur'] = colorInput.value;
              });
            } else {
              if (!data.properties) data.properties = {};
              data.properties['Couleur'] = colorInput.value;
            }
            body = JSON.stringify(data);
          } catch(e) {}
        }
      }
    }
    return originalSend.apply(this, [body]);
  };
})();

document.addEventListener('DOMContentLoaded', function() {

  var basePriceElement = document.querySelector('.product-price--original');
  var plateSizeEl = document.querySelector('#plateSize');
  var groundHoldingEl = document.querySelector('#groundHolding');

  if (basePriceElement && plateSizeEl && groundHoldingEl) {
    var basePrice = parseFloat(basePriceElement.textContent.replace(/[^\d,.-]/g, '').replace(',', '.'));

    function updatePrice() {
      var additionalPrice = 0;
      var plateSize = plateSizeEl.value;
      var groundHolding = groundHoldingEl.value;

      if (plateSize === '70/75 cm' || plateSize === '80/85 cm') {
        additionalPrice += 2.40;
      } else if (plateSize === '85/90 cm') {
        additionalPrice += 3.60;
      }

      if (groundHolding === '3 pieds' || groundHolding === '1 poteau central') {
        additionalPrice += 2.40;
      }

      var newPrice = basePrice + additionalPrice;
      basePriceElement.textContent = '€' + newPrice.toFixed(2);
    }

    plateSizeEl.addEventListener('change', updatePrice);
    groundHoldingEl.addEventListener('change', updatePrice);
  }

  document.querySelectorAll('input[name="__color_picker"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var selectedColorText = document.getElementById('selectedColor');
      var hiddenColorInput = document.getElementById('colorHiddenInput');
      if (selectedColorText) selectedColorText.textContent = this.value;
      if (hiddenColorInput) hiddenColorInput.value = this.value;
    });
  });

});
